module.exports = __webpack_public_path__ + "img/group-plus-icon.9626d216.svg";